/**
 * 微信重定向判断
 */
import router from '../../router'
import { getObjectByUrlParams } from '../../utils/tools'

/**
 * 判断处理微信重定向
 */
const handleWxRedirect = () => {
  if (location.search) {
    if (location.search.split('?')[1]) {
      const query = getObjectByUrlParams(location.search.split('?')[1])
      if (query.code) {
        window.location.replace(`${location.origin}${location.pathname}#/auth${location.search}`)
      }
    }
  }
}

export default handleWxRedirect
